import React, { useState, useEffect  } from 'react';
import { useRecordContext } from 'react-admin';
import DeleteIcon from '@mui/icons-material/Delete';

import { List, Datagrid, TextField, DeleteButton, useNotify, useDataProvider } from 'react-admin';
import { Typography, TextField as MuiTextField, Select, MenuItem, FormControl, InputLabel, Button } from '@mui/material';
import { baseUrl } from './consts';
import CustomEditButton from './CustomEditButton'; 
const ServiceGroupsList = () => {
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const [serviceGroups, setServiceGroups] = useState([]);
    const [packages, setPackages] = useState([]);
    const [englishGroupNames, setEnglishGroupNames] = useState([]);
    const [selectedPackageID, setSelectedPackageID] = useState("");
    const [selectedEnglishGroupName, setSelectedEnglishGroupName] = useState('');
    const [arabicGroupName, setArabicGroupName] = useState('');
    const [showOtherFields, setShowOtherFields] = useState(false);
    const [newEnglishGroupName, setNewEnglishGroupName] = useState('');
    const [newArabicGroupName, setNewArabicGroupName] = useState('');
    const [arabicServiceName, setArabicServiceName] = useState('');
    const [arabicServiceDescription, setArabicServiceDescription] = useState('');
    const [englishServiceDescription, setEnglishServiceDescription] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('');
    const [loading, setLoading] = useState(true);
    const [editingGroup, setEditingGroup] = useState(null);
    const [totalPrice, setTotalPrice] = useState('');
    // Fetch service groups from the backend
    const fetchServiceGroups = () => {
        setLoading(true);
        dataProvider.getList('service-groups', {})
            .then(({ data }) => {
                setServiceGroups(data);
                const uniqueEnglishGroupNames = [...new Set(data.map((group) => group.english_group_name))];
                setEnglishGroupNames(uniqueEnglishGroupNames);
                fetchPackages();
            })
            .catch(() => {
                notify('Failed to fetch service groups', { type: 'error' });
            })
            .finally(() => {
                setLoading(false);
            });
    };

const handleEdit = (group) => {
    console.log("Loading into edit mode:", group);
    setEditingGroup({ 
        ...group, 
    total_price: group.total_price ?? 0
    });
};
    const handleUpdateServiceGroup = async () => {
        if (!editingGroup) return;
        

        try {
            console.log("Updating service group with data:", {
                id: editingGroup.group_id,
                data: {
                    group_id: editingGroup.group_id,
                    srvid:editingGroup.srvid,
                    english_group_name: editingGroup.english_group_name,
                    arabic_group_name: editingGroup.arabic_group_name,
                    arabic_service_name: editingGroup.arabic_service_name,
                    arabic_service_description: editingGroup.arabic_service_description,
                    english_service_description: editingGroup.english_service_description,
                    payment_method: editingGroup.payment_method,
total_price: parseFloat(editingGroup.total_price),                },
            });

            await dataProvider.update('service-groups', {
                id: editingGroup.group_id,
                data: {
                    group_id: editingGroup.group_id,
                    srvid:editingGroup.srvid,
                    english_group_name: editingGroup.english_group_name,
                    arabic_group_name: editingGroup.arabic_group_name,
                    arabic_service_name: editingGroup.arabic_service_name,
                    arabic_service_description: editingGroup.arabic_service_description,
                    english_service_description: editingGroup.english_service_description,
                    payment_method: editingGroup.payment_method,
                    total_price: parseFloat(editingGroup.total_price),
                },
            });

            notify('Service group updated successfully', { type: 'info' });
            setEditingGroup(null);
            fetchServiceGroups(); // Refresh the list
        } catch (error) {
            console.error('Error updating service group:', error);
            notify('Failed to update service group', { type: 'error' });
        }
    };

    // Fetch packages from a custom endpoint
    const fetchPackages = () => {
        fetch(baseUrl + '/v1/shared/packages', {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.packages) {
                    const availablePackages = data.packages.filter(pkg =>
                        !serviceGroups.some(group => group.srvid === pkg.package_id)
                    );
                    setPackages(availablePackages);
                } else {
                    setPackages([]);
                }
            })
            .catch(() => {
                notify('Failed to fetch packages', { type: 'error' });
            });
    };

    // Initial fetch on component mount
    useEffect(() => {
        fetchServiceGroups();
    }, []);

    // Handle English group name selection
    const handleEnglishGroupNameChange = (e) => {
        const selectedName = e.target.value;
        setSelectedEnglishGroupName(selectedName);

        if (selectedName === 'Other') {
            setShowOtherFields(true);
            setArabicGroupName('');
        } else {
            setShowOtherFields(false);
            const correspondingArabicName = serviceGroups.find(group => group.english_group_name === selectedName)?.arabic_group_name || '';
            setArabicGroupName(correspondingArabicName);
        }
    };

    // Condition to show service fields based on selection
    const shouldShowServiceFields = selectedPackageID && (
        showOtherFields ? (newEnglishGroupName && newArabicGroupName) : (selectedEnglishGroupName && arabicGroupName)
    );

    // Handle adding a new service group and its associated service details
    const handleAddServiceGroup = async () => {
        let finalEnglishGroupName = newEnglishGroupName;
        let finalArabicGroupName = newArabicGroupName;

        if (!showOtherFields) {
            finalEnglishGroupName = selectedEnglishGroupName;
            finalArabicGroupName = arabicGroupName;
        }

        if (!finalEnglishGroupName || !finalArabicGroupName) {
            notify('Both English and Arabic group names are required', { type: 'warning' });
            return;
        }

        if (!selectedPackageID) {
            notify('Please select a package', { type: 'warning' });
            return;
        }

        const serviceGroupPayload = {
            english_group_name: finalEnglishGroupName,
            arabic_group_name: finalArabicGroupName,
            srvid: selectedPackageID,
            arabic_service_name: arabicServiceName,
            arabic_service_description: arabicServiceDescription,
            english_service_description: englishServiceDescription,
            payment_method: paymentMethod,
            total_price: parseFloat(totalPrice)        };

        try {
            const serviceGroupResponse = await dataProvider.create('service-groups', { data: serviceGroupPayload });
            const createdGroupId = serviceGroupResponse.data?.id;

            if (!createdGroupId) {
                throw new Error("Service group creation response is missing 'id'");
            }

            notify('Service group and service added successfully', { type: 'info' });
            resetFormFields();

            // Re-fetch the service groups to ensure all data is up to date
            fetchServiceGroups();

            // Update packages to remove the selected package
            setPackages((prevPackages) => prevPackages.filter(pkg => pkg.package_id !== selectedPackageID));
        } catch (error) {
            console.error('Error adding service group or service:', error);
            notify('Failed to add service group or service', { type: 'error' });
        }
    };

    // Reset form fields after submission
    const resetFormFields = () => {
        setTotalPrice('')
        setNewEnglishGroupName('');
        setNewArabicGroupName('');
        setArabicServiceName('');
        setArabicServiceDescription('');
        setEnglishServiceDescription('');
        setSelectedPackageID('');
        setSelectedEnglishGroupName('');
        setPaymentMethod('');
    };

    // Handle deletion of a service group and associated services
const handleDeleteServiceGroup = (srvid) => {
    dataProvider.delete('service-groups', { id: srvid })
        .then(() => {
            notify('Service group deleted successfully', { type: 'info' });

            setServiceGroups(prev =>
                prev.filter(group => group.srvid !== srvid)
            );

            fetchPackages();
        })
        .catch(() => {
            notify('Failed to delete service group', { type: 'error' });
        });
};


    const ServiceGroupDeleteButton = ({ handleDelete }) => {
    const record = useRecordContext();
        console.log('DELETE RECORD:', record);

    if (!record) return null;
    const onDelete = () => {
        if (window.confirm('Are you sure you want to delete this service group?')) {
            handleDelete(record.srvid);
        }
    };

    return (
        <Button
            label="Delete"
            onClick={onDelete}
        >
            <DeleteIcon />
        </Button>
    );
}



    return (
        <List title="Service Groups">
            {editingGroup && (
                <div style={{ marginBottom: '16px', display: 'flex', flexDirection: 'column' }}>
                    <MuiTextField
                        label="English Group Name"
                        value={editingGroup.english_group_name}
                        onChange={(e) => setEditingGroup({ ...editingGroup, english_group_name: e.target.value })}
                        variant="outlined"
                        size="small"
                        style={{ marginBottom: '8px' }}
                    />

<MuiTextField
    label="Total Price"
    type="number"
    value={editingGroup.total_price}
    onChange={(e) =>
        setEditingGroup({ ...editingGroup, total_price: e.target.value })
    }
    variant="outlined"
    size="small"
    style={{ marginBottom: '8px' }}
/>
                    
                    <MuiTextField
                        label="Arabic Group Name"
                        value={editingGroup.arabic_group_name}
                        onChange={(e) => setEditingGroup({ ...editingGroup, arabic_group_name: e.target.value })}
                        variant="outlined"
                        size="small"
                        style={{ marginBottom: '8px' }}
                    />
                    <MuiTextField
                        label="Arabic Service Name"
                        value={editingGroup.arabic_service_name}
                        onChange={(e) => setEditingGroup({ ...editingGroup, arabic_service_name: e.target.value })}
                        variant="outlined"
                        size="small"
                        style={{ marginBottom: '8px' }}
                    />
                    <MuiTextField
                        label="Arabic Service Description"
                        value={editingGroup.arabic_service_description}
                        onChange={(e) => setEditingGroup({ ...editingGroup, arabic_service_description: e.target.value })}
                        variant="outlined"
                        size="small"
                        style={{ marginBottom: '8px' }}
                        multiline
                        rows={4}
                    />
                    <MuiTextField
                        label="English Service Description"
                        value={editingGroup.english_service_description}
                        onChange={(e) => setEditingGroup({ ...editingGroup, english_service_description: e.target.value })}
                        variant="outlined"
                        size="small"
                        style={{ marginBottom: '8px' }}
                        multiline
                        rows={4}
                    />

                    <FormControl variant="outlined" size="small" style={{ marginBottom: '8px', minWidth: '200px' }}>
                        <InputLabel>Payment Method</InputLabel>
                        <Select
                            value={editingGroup.payment_method}
                            onChange={(e) => setEditingGroup({ ...editingGroup, payment_method: e.target.value })}
                            label="Payment Method"
                        >
                            <MenuItem value="refill card">Refill Card</MenuItem>
                            <MenuItem value="credit card">Credit Card</MenuItem>
                            <MenuItem value="both">Both</MenuItem>
                        </Select>
                    </FormControl>
                    <Button onClick={handleUpdateServiceGroup} variant="contained" color="primary">
                        Update Service Group
                    </Button>
                    <Button onClick={() => setEditingGroup(null)} variant="contained" color="secondary" style={{ marginTop: '8px' }}>
                        Cancel
                    </Button>
                </div>
            )}

            <div style={{ marginBottom: '16px', display: 'flex', flexDirection: 'column' }}>
                <FormControl variant="outlined" size="small" style={{ marginBottom: '8px', minWidth: '200px' }}>
                    <InputLabel>Select Package</InputLabel>
                    <Select
                        value={selectedPackageID || ""}
                        onChange={(e) => setSelectedPackageID(e.target.value)}
                        label="Select Package"
                    >
                        {packages.map((pkg) => (
                            <MenuItem key={pkg.package_id} value={pkg.package_id}>
                                {pkg.package_title}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl variant="outlined" size="small" style={{ marginBottom: '8px', minWidth: '200px' }}>
                    <InputLabel>Select English Group Name</InputLabel>
                    <Select
                        value={selectedEnglishGroupName}
                        onChange={handleEnglishGroupNameChange}
                        label="Select English Group Name"
                    >
                        {englishGroupNames.map((name, index) => (
                            <MenuItem key={index} value={name}>{name}</MenuItem>
                        ))}
                        <MenuItem value="Other">Other</MenuItem>
                    </Select>
                    <MuiTextField
    label="Total Price"
    type="number"
    value={totalPrice}
    onChange={(e) => setTotalPrice(e.target.value)}
    variant="outlined"
    size="small"
    style={{ marginBottom: '8px' }}
/>             

   </FormControl>

                {!showOtherFields && (
                    <MuiTextField
                        label="Arabic Group Name"
                        value={arabicGroupName}
                        variant="outlined"
                        size="small"
                        InputProps={{ readOnly: true }}
                        style={{ marginBottom: '8px' }}
                    />
                    
                )}

                {showOtherFields && (
                    <>
                    
                        <MuiTextField
                            label="English Group Name"
                            value={newEnglishGroupName}
                            onChange={(e) => setNewEnglishGroupName(e.target.value)}
                            variant="outlined"
                            size="small"
                            style={{ marginBottom: '8px' }}
                        />
                        <MuiTextField
                            label="Arabic Group Name"
                            value={newArabicGroupName}
                            onChange={(e) => setNewArabicGroupName(e.target.value)}
                            variant="outlined"
                            size="small"
                            style={{ marginBottom: '8px' }}
                        />
                    </>
                )}

                <FormControl variant="outlined" size="small" style={{ marginBottom: '8px', minWidth: '200px' }}>
                    <InputLabel>Payment Method</InputLabel>
                    <Select
                        value={paymentMethod}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        label="Payment Method"
                    >
                        <MenuItem value="refill card">Refill Card</MenuItem>
                        <MenuItem value="credit card">Credit Card</MenuItem>
                        <MenuItem value="both">Both</MenuItem>
                    </Select>
                </FormControl>

                {shouldShowServiceFields && (
                    <>
                        <MuiTextField
                            label="Arabic Service Name"
                            value={arabicServiceName}
                            onChange={(e) => setArabicServiceName(e.target.value)}
                            variant="outlined"
                            size="small"
                            style={{ marginBottom: '8px' }}
                        />
                        <MuiTextField
                            label="Arabic Service Description"
                            value={arabicServiceDescription}
                            onChange={(e) => setArabicServiceDescription(e.target.value)}
                            variant="outlined"
                            size="small"
                            style={{ marginBottom: '8px' }}
                            multiline
                            rows={4}
                        />
                        <MuiTextField
                            label="English Service Description"
                            value={englishServiceDescription}
                            onChange={(e) => setEnglishServiceDescription(e.target.value)}
                            variant="outlined"
                            size="small"
                            style={{ marginBottom: '8px' }}
                            multiline
                            rows={4}
                        />
                    </>
                )}

                <Button
                    onClick={handleAddServiceGroup}
                    disabled={!selectedPackageID || (!showOtherFields && (!selectedEnglishGroupName || !arabicGroupName))}
                    variant="contained"
                    color="primary"
                >
                    Add Service
                </Button>
            </div>

            {loading ? (
                <Typography variant="body1">Loading...</Typography>
            ) : (
                <Datagrid data={serviceGroups}>
                    <TextField source="srvid" label="Service ID" />
                    <TextField source="service_name" label="Service Name" />
                    <TextField source="english_group_name" label="English Group Name" />
                    <TextField source="arabic_group_name" label="Arabic Group Name" />
                    <TextField source="arabic_service_name" label="Arabic Service Name" />
                    <TextField source="arabic_service_description" label="Arabic Service Description" />
                    <TextField source="english_service_description" label="English Service Description" />
                    <TextField source="payment_method" label="Payment Method" />
                    <TextField source="total_price" label="Total Price" />
                        <CustomEditButton handleEdit={handleEdit} />
                     <ServiceGroupDeleteButton handleDelete={handleDeleteServiceGroup} />

                </Datagrid>
            )}
        </List>
    );
};

export default ServiceGroupsList;